var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('Tables',{ref:"tableGrid",attrs:{"columns":[
      'Período Movimento',
      'Descrição',
      'Nível Risco',
      'Nível Risco Desc.',
      'Modalidade Bacen',
      'Sub Modal. Bacen',
      'Val. Vencer 30',
      'Val. Vencer 31 a 60',
      'Val. Vencer Prazo Indeterminado',
      'Val. Vencer 360',
      'Val. Vencer Acima 360',
      'Val. Vencer Total',
      'Val. Coobrigacao',
      'Val. Prejuízo',
      'Val. Devedor',
      'Val. Vencido 90',
      'Val. Vencido Acima 90',
      'Val. Vencido Total'
    ],"showTipFooter":false},on:{"Load":_vm.onLoad}},_vm._l((this.objList),function(obj){return _c('tr',{key:obj.id},[_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.periodoMovimento ? _vm.formatPeriod(obj.periodoMovimento) : ''}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.nome}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.nivelRisco}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.nivelRiscoDescricao}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.modalidadeBacen}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.subModalidadeBacen}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valVencer30
            ? _vm.formatValue(obj.valVencer30)
            : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valVencer31a60
            ? _vm.formatValue(obj.valVencer31a60)
            : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valVencerPrazoIndeterminado
            ? _vm.formatValue(obj.valVencerPrazoIndeterminado)
            : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valVencer360
            ? _vm.formatValue(obj.valVencer360)
            : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valVencerAcima360
            ? _vm.formatValue(obj.valVencerAcima360)
            : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valVencerTotal
            ? _vm.formatValue(obj.valVencerTotal)
            : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valCoobrigacao
            ? _vm.formatValue(obj.valCoobrigacao)
            : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valPrejuizo
            ? _vm.formatValue(obj.valPrejuizo)
            : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valDevedor ? _vm.formatValue(obj.valDevedor) : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valVencido90
            ? _vm.formatValue(obj.valVencido90)
            : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valVencidoAcima90
            ? _vm.formatValue(obj.valVencidoAcima90)
            : 'R$ 0,00'}}),_vm._v(" "),_c('TableColumn',{attrs:{"IsText":true,"status":1,"value":obj.valVencidoTotal
            ? _vm.formatValue(obj.valVencidoTotal)
            : 'R$ 0,00'}})],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b55be450","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/associate/tabs/IndebtednessSicoob.vue
// module id = null
// module chunks = 